import React, { useState, useCallback } from "react";
import { MasonryPhotoAlbum } from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "react-photo-album/masonry.css";

import { Container, Title, GalleryWrapper } from "./styles";

export default function Galeria() {
  const [index, setIndex] = useState(-1);

  const photos = [
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009641/website/Galeria/2026/material-did%C3%A1tico-our-place-escola-de-idiomas_egjueo.jpg",
      width: 7,
      height: 11,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009641/website/Galeria/2026/mesa-estudantil-our-place-escola-de-idiomas_k5lbql.jpg",
      width: 16,
      height: 9,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009641/website/Galeria/2026/sala-de-aula-our-place-escola-de-idiomas_jn99zz.jpg",
      width: 2,
      height: 3,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009640/website/Galeria/2026/brinquedo-did%C3%A1tico-our-place-2_i7dd6y.jpg",
      width: 3,
      height: 4,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009641/website/Galeria/2026/brinquedo-did%C3%A1tico-our-place_l9dh1p.jpg",
      width: 16,
      height: 9,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009640/website/Galeria/2026/espa%C3%A7o-l%C3%BAdico-our-place_ltqw7r.jpg",
      width: 16,
      height: 9,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009640/website/Galeria/2026/espa%C3%A7o-l%C3%BAdico-our-place-2_apqavp.jpg",
      width: 16,
      height: 9,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1748341922/website/Galeria/Novas%20Fotos/xyjtrtbz0u835amkt09o.jpg",
      width: 16,
      height: 9,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009640/website/Galeria/2026/espa%C3%A7o-infantil-our-place_tt9nln.jpg",
      width: 2,
      height: 3,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009640/website/Galeria/2026/mochila-our-place-escola-de-idiomas_a4z54w.jpg",
      width: 16,
      height: 9,
    },
    {
      src: "https://res.cloudinary.com/ourplaceeglishschool/image/upload/v1790009639/website/Galeria/2026/espa%C3%A7o-infantil-our-place-2_vnzdvx.jpg",
      width: 2,
      height: 3,
    },
  ];

  const openLightbox = useCallback(({ index }) => {
    setIndex(index);
  }, []);
  const enhancedPhotos = photos.map((photo) => ({
    ...photo,
    src: photo.src.replace("/upload/", "/upload/w_400,q_auto,f_auto/"),
    srcSet: [400, 800, 1200].map((w) => ({
      src: photo.src.replace("/upload/", `/upload/w_${w},q_auto,f_auto/`),
      width: w,
      height: Math.round((photo.height / photo.width) * w),
    })),
  }));

  return (
    <Container id="galeria">
      <Title>Galeria</Title>
      <GalleryWrapper>
        <MasonryPhotoAlbum
        padding={0}
        spacing={16}
        onClick={openLightbox}
        photos={enhancedPhotos}
        columns={(containerWidth) => {
          if (containerWidth < 500) return 1;
          if (containerWidth < 768) return 2;
          if (containerWidth < 1300) return 3;
          return 4;
        }}
        sizes={{
          size: "(max-width: 768px) 100vw, (max-width: 1024px) 50vw, (max-width: 1300px) 33vw, 25vw",
        }}
        />

        <Lightbox
          open={index >= 0}
          index={index}
          close={() => setIndex(-1)}
          slides={enhancedPhotos.map((photo) => ({
            src: photo.src.replace("/upload/", "/upload/w_1600,q_auto,f_auto/"),
            srcSet: photo.srcSet,
          }))}
        />
      </GalleryWrapper>
    </Container>
  );
}